import { render } from "./Label.vue?vue&type=template&id=0c5d202a"
const script = {}

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Filter/Support/Label.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c5d202a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c5d202a', __exports__)) {
    api.reload('0c5d202a', __exports__)
  }
  
  module.hot.accept("./Label.vue?vue&type=template&id=0c5d202a", () => {
    api.rerender('0c5d202a', render)
  })

}


export default __exports__